import { Injectable } from '@angular/core';

@Injectable()
export class FileSaverService {
  constructor() {}

  save(blob: Blob, fileName: string): void {
    const newBlob = new Blob([blob], { type: blob.type });

    const objectUrl = window.URL.createObjectURL(newBlob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;

    link.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );

    setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
      link.remove();
    }, 100);
  }
}
